// Getters (GET*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const OVERVIEW_PANEL_GET_CURRENT = 'OVERVIEW_PANEL_GET_CURRENT';
export const OVERVIEW_PANEL_IS_VISIBLE = 'OVERVIEW_PANEL_IS_VISIBLE';

// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const OVERVIEW_PANEL_SET_CURRENT = 'OVERVIEW_PANEL_SET_CURRENT';
export const OVERVIEW_PANEL_SET_VISIBILITY = 'OVERVIEW_PANEL_SET_VISIBILITY';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*, ANY*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const OVERVIEW_PANEL_CHANGE_CURRENT = 'OVERVIEW_PANEL_CHANGE_CURRENT';
export const OVERVIEW_PANEL_HIDE = 'OVERVIEW_PANEL_HIDE';



// WEBPACK FOOTER //
// ./src/store/modules/overview-panel/types.js